import AuditResultBlock from "../../components/personal/AuditResultPage/AuditResultBlock";
import MainNavbar from "../../components/reuse/MainNavbar";
import PersonDropdown from "../../components/reuse/PersonDropdown";
import { TypicalPageStructure } from "../../components/reuse/TypicalPageStructure";

const AuditResultPage = () => {
    return(
        <>
        <TypicalPageStructure pageLabel={"Результаты аудита"}>
            <AuditResultBlock/>
        </TypicalPageStructure>
        </>
    )
}

export default AuditResultPage;